import { useQuery } from '@tanstack/react-query';

import { NotionBlock } from '@Components';
import { bopsApi } from '@Network';

interface NotionPageResponse {
  page_id: string;
  title: string;
  url: string;
  blocks: NotionBlock[];
}

function useResources(pageId?: string, isDatabase = false) {
  const notionPageData = useQuery<NotionPageResponse>({
    queryKey: ['resources', isDatabase ? 'database' : 'page', pageId],
    queryFn: () =>
      isDatabase ? bopsApi.getDocumentationDatabase(pageId || '') : bopsApi.getDocumentationPage(pageId || ''),
    enabled: !!pageId,
  });

  return {
    notionPageData,
  };
}

export default useResources;
export type { NotionPageResponse };
